import { Component, NgZone, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { SessionStorageService } from 'app/shared/services/session-storage.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import swal from 'sweetalert2';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'app/App Store/state';
import { setPageNumber } from 'app/App Store/actions/pageChange.actions';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class ProjectsComponent implements OnInit {


  project_type: any
  @ViewChild(DatatableComponent) table: DatatableComponent;
  @ViewChild('name') inputName;

  page = {
    pageNumber: 0,
    offset: 0,
    pageSize: 100,
    totalPages: 0
  };
  // row data
  public rows = [];
  public filterRows = [];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  selectedValue = ''
  isFilter: boolean = false
  // column header
  public columns = [
    { name: " Name", prop: "name" },
    { name: "Project Budget", prop: "projectbudget" },
    { name: "Skills", prop: "skills" },
    { name: "Team", prop: "team" },
    { name: "Actions", prop: "actions" },
  ];

  // private
  private tempData = [];
  imageBaseUrl = environment.apiUrls.course_imageUrl;
  user_role: any
  skills = []

  statusList = []
  priorityList = []
  activeTab = 'current'
  job_id: any
  catId = '6319d5025ab9e462a96cfbba'
  technology_List = []
  selectedTechnology: any = null

  pamentStatusList = [
    { name: 'received', label: 'Payment Received' },
    { name: 'due', label: 'Payement Due' },
  ]
  dropdownList = [
    { name: 'All', id: '' },
    { name:'Contract', id:'65264bf30af5538a9d4094a4'},
    { name: 'Project', id: '644a5c52af0db342c32eeaf8' },
    { name: 'Product', id: '644a5c84af0db342c32eeb02' },
  ];
  selectedPaymentStatus = 'due'
  selectedPaymentMode = '6436812a92675911b577d800'
  paymentModeId = '6436808f92675911b577d7c3'
  paymentMode = []
  payment_model = {
    mode: '',
    job_id: '',
    paid_amount: '',
    payment_notes: '',
    payment_status: '',
    next_paymentdate: ''
  }
  payment_data: any
  lead_data: any
  alert_list = [
    { id: 'yes', name: 'Yes' },
    { id: 'no', name: 'No' },
  ]
  input_option ={}
  workon_id='644a5c52af0db342c32eeaf8'

  guideline_data:any
  fileData:File;
  imgUrl: string | ArrayBuffer;
  isEdit :boolean = false
  pageNumberSubscription : Subscription
  pageNo
  isEditAlertNotes : boolean = false
  isEditNotes : boolean = false
  isEditAdminNotes : boolean = false

  clients_list =[]
  selected_client = null
  row_id:any

  constructor(public apiService: ApiService, private spinner: NgxSpinnerService,
    public toastr: ToastrService,private modalService: NgbModal,
    private session: SessionStorageService, private activerouter: ActivatedRoute,
    private route: Router,private store: Store<AppState>) {

    this.user_role = JSON.parse(localStorage.getItem('user'))
    let setting_data = JSON.parse(localStorage.getItem('setting-record'))
    let key_data = setting_data.filter((item) => item.key == 'Jobs') 
    this.guideline_data = key_data[0]?._id
    this.project_type='All'

    this.activerouter.queryParams
    .subscribe((params: any) => {
      this.activeTab = params['status'];
      this.pageNo = +params['page'];
      if(this.pageNo>0){
        this.setPage(this.pageNo);
      }
      else this.page.pageNumber = this.pageNo?this.pageNo-1:0
    })
    this.pageNumberSubscription = this.store.select(state => state.page.pageNumber)
    .subscribe(pageNumber => {
      this.page.pageNumber = pageNumber;
      if(pageNumber !==undefined){
        this.page.pageNumber = pageNumber ?  pageNumber-1 :0
      }
    });

    this.getJobStatusList()
    if(this.activeTab) this.activeJobTab(this.activeTab,this.pageNo?this.pageNo:1)
    if(!this.activeTab) this.activeJobTab('current',this.pageNo?this.pageNo:1)
  }

  ngOnInit() {
    this.getUserById()
    this.getTechnologyList()
    this.getJobPriorityList()
    this.paymentModeList()
    this.getClientList()
  }
  setPage(pageNumber: number) {
    this.store.dispatch(setPageNumber({ pageNumber }));
  }
  addNewJob(){
    window.open('/jobs/add?type=project')
  }
  
  editJob(row) {
    // this.route.navigate(['jobs/edit', row?._id])
        window.open(`/jobs/edit/${row?._id}?type=project`)

  }
  getJobStatusList() {
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getLeadsStatusList("jobstatus").subscribe((res: any) => {
      this.spinner.hide()
      this.statusList = res.data
      const desiredStatusOrder = ['pending', 'current', 'onhold', 'closed','archive'];

      // Sort the items in descending order based on their status property
      this.statusList.sort((a, b) => {
        const aIndex = desiredStatusOrder.indexOf(a.name);
        const bIndex = desiredStatusOrder.indexOf(b.name);
        return aIndex - bIndex;
      });
      this.setAndGetJobByStatus()
    })
  }
  getJobPriorityList() {
    this.apiService.getLeadsStatusList("jobpriority").subscribe((res: any) => {
      this.priorityList = res.data
    })
  }
  setAndGetJobByStatus() {
    this.activerouter.queryParams
      .subscribe((params: any) => {
        this.activeTab = params?.status;
        switch (this.activeTab) {
          case 'current':
            this.getJobsList(this.activeTab);
            break;
          case 'pending':
            this.getJobsList(this.activeTab);
            break
          case 'onhold':
            this.getJobsList(this.activeTab);
            break;
          case 'closed':
            this.getJobsList(this.activeTab);
            break;
          case 'archive':
          this.getJobsList(this.activeTab);
          break;
          default:
            this.activeTab = ''
        }
      })
  }
  activeJobTab(tab,page) {
    if(page<1){ page =1}
    const activetab = tab;
    this.activeTab = tab
    if (activetab !== '') {
      this.route.navigate(
        [],
        { relativeTo: this.activerouter, queryParams: { status: activetab ,  page : page },queryParamsHandling: 'merge' }
      );
    }
  }
  getJobsList(statusName) {
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    let status = this.statusList.find((item) => item.name == this.activeTab)
    this.apiService.getJobsByStatus(status?._id, this.page.pageNumber + 1, this.limitRef, this.workon_id, statusName).subscribe((res: any) => {
      this.spinner.hide()
      if(res.statusCode ===200){
        this.rows = res?.data?.items
        this.page.totalPages = res?.data?.totalCount
      }
      else {
        this.toastr.error(res.error)
      }
     
    })
  }
  getTechnologyList() {
    this.apiService.getTagByTagCatgoryId(this.catId).subscribe((res: any) => {
      this.technology_List = res.data.slice(0, 4)
      let list = { _id: 'all', displayname: 'All' }
      this.technology_List.push(list)
      this.technology_List.sort((a, b) => {
        if (a.displayname < b.displayname) { return -1; }
        if (a.displayname > b.displayname) { return 1; }
        return 0;
      });
    })
  }
  getUserById() {
    this.apiService.getUserbyId(this.user_role.id).subscribe((res: any) => {
      let emp_data = res?.data
      this.selectedTechnology = emp_data?.technology[0]?.displayname
      if (emp_data?.technology.length == 0) {
        this.selectedTechnology = 'All'
      }
    })
  }
  getTechnologyId(event_id, event_name) {
    this.selectedTechnology = event_name
    if (event_id.displayname !== 'All' && this.selectedTechnology) {
      let formData = new FormData();
      formData.append('technology', event_id)
      this.apiService.updateUser(this.user_role.id, formData).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.setAndGetJobByStatus()
        }
        else {
          this.toastr.error(res.error)
        }
      })
    }
    else {
      let formData = new FormData();
      formData.append('technology', event_id._id)
      this.apiService.updateUser(this.user_role.id, formData).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.setAndGetJobByStatus()
        }
        else {
          this.toastr.error(res.error)
        }
      })
    }

  }
  pageChangeData(page: any) {
    this.route.navigate([], {
      relativeTo: this.activerouter,
      queryParams: { page: page.offset +1 },
      queryParamsHandling: 'merge' // keep existing query params
    });
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    let status = this.statusList.find((item) => item.name == this.activeTab)
    this.apiService.getJobsByStatus(status?._id, this.page.pageNumber + 1, this.limitRef, this.workon_id, this.activeTab).subscribe((res: any) => {
      this.spinner.hide()
      this.setPage(page.offset + 1)
      this.rows = res.data.items
      this.page.totalPages = res.data.totalCount
    })
  }
  getJobFilter(data) {
    let search = data
    if (search) {
      this.apiService.getFilterJobs(search).subscribe((res: any) => {
        this.rows = res.data
      })
    }
    else {
      this.setAndGetJobByStatus()
    }
  }
  resetFilter() {
   
    this.inputName.nativeElement.value = null;
    this.setAndGetJobByStatus()
  }
  updateLimit(limit) {
    this.limitRef = limit.target.value;
    this.apiService.getAllJobs(1, this.limitRef).subscribe((res: any) => {
    })
  }
  deleteJob(password) {
    this.apiService.jobDelete(this.job_id, password).subscribe((res: any) => {
      if (res.statusCode === 200) {
        swal.fire({
          icon: "success",
          title: 'Deleted!',
          text: 'Your file has been deleted.',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
        this.setAndGetJobByStatus()
      }
      else {
        swal.fire({
          icon: "error",
          title: 'Error!',
          text: `${res.error}`,
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }

    })
  }



  // ================== Delete Alert ========================
  Delete(id: any) {
    this.job_id = id
    swal.fire({
      text: "Please Enter Password",
      input: 'password',
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        this.deleteJob(result.value)

      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }

  // ==========================================
  updateJobStatus(id, status) {

    let priority
    this.input_option = {}
    this.priorityList.forEach(item => {
      // if (status.name == 'current') {
      //   if (item.name === 'normal') {
      this.input_option[item._id] = item.displayname;
      priority = item._id
      //   }
      // }
      // else if (status.name == 'onhold') {
      //   if (item.name === 'prospect' || item.name === 'hot' || item.name === 'nurture') this.input_option[item._id] = item.displayname;
      //   if (item.name == "prospect") priority = item._id
      // }
      // else if (status.name == 'closed') {
      //   if (item.name === 'won' || item.name === 'lost') this.input_option[item._id] = item.displayname;
      //   if (item.name == "lost") priority = item._id
      // }
    });
    swal.fire({
      title: 'Select Job Priority',
      input: 'select',
      inputOptions: this.input_option,
      inputValue: priority,
      inputPlaceholder: 'Select Job Priority',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2F8BE6',
      cancelButtonColor: '#F55252',
      confirmButtonText: 'Yes!',
      customClass: {
        confirmButton: 'btn btn-warning',
        cancelButton: 'btn btn-danger ml-1'
      },
      buttonsStyling: false,
    }).then((result) => {
      if (result.value) {
        let body = { status: status._id, priority: priority }
        const priorityId = result.value;
        body.priority = priorityId
        this.apiService.updateJob(id, body).subscribe((res: any) => {
          if (res.statusCode === 200) {
            swal.fire({
              icon: "success",
              title: 'Move!',
              text: 'Updated Successfully.',
              customClass: {
                confirmButton: 'btn btn-success'
              },
            })
            this.setAndGetJobByStatus()
          }
          else {
            swal.fire({
              icon: "error",
              title: 'Move!',
              text: `${res.error}`,
              customClass: {
                confirmButton: 'btn btn-success'
              },
            })
          }
        })


      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });

  }
  // ==============================================

  updateJobPriority(id, priority_id) {

    let body = {
      priority: priority_id
    }
    if (id) {
      this.apiService.updateJob(id, body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.toastr.success('Job priority update successfully')
          this.setAndGetJobByStatus()
        }
        else {
          this.toastr.error(res.error)
        }
      })
    }
  }
  openModal(content, id) {
    this.payment_model.job_id = id
    const modalRef = this.modalService.open(content);
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
    this.getPaymentByJobId(this.payment_model.job_id)
  }
  getPaymentByJobId(id) {
    this.apiService.getTransactionByJobId(id).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.payment_data = res.data
      }
    })
  }
  payment() {
    let body = {
      mode: this.selectedPaymentMode,
      job_id: this.payment_model.job_id,
      paid_amount: this.payment_model.paid_amount,
      payment_notes: this.payment_model.payment_notes,
      payment_status: this.selectedPaymentStatus,
      next_paymentdate: this.payment_model.next_paymentdate,
    }
    if (this.payment_model.job_id) {
      this.apiService.createJobTransaction(body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.toastr.success('Payment Successfull')
          this.modalService.dismissAll()
        }
        else {
          this.toastr.error(res.error)
        }
      })
    }
  }
  paymentModeList() {
    this.apiService.getTagByTagCatgoryId(this.paymentModeId).subscribe((res: any) => {
      this.paymentMode = res.data
    })
  }
  getPaymentModeId(event: any) {
    this.selectedPaymentMode
  }
  openModal2(content, data) {
    const modalOptions: NgbModalOptions = {
      // size: 'lg' // Set custom width here
    };
    this.lead_data = data.leads
    const modalRef = this.modalService.open(content, modalOptions);
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  updateJobAlert(id, data) {
    let body = {
      isalert: data
    }
    if (id) {
      this.apiService.updateJob(id, body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.toastr.success('Job alert update successfully')
          this.setAndGetJobByStatus()
        }
        else {
          this.toastr.error(res.error)
        }
      })
    }
  }

  updateWorkonJob(id) {
    this.job_id = id
    swal.fire({
      title: 'Select an option',
      html: `
        <select id="dropdown" class="swal2-input">
          ${this.dropdownList.map(option => `<option value="${option.id}">${option.name}</option>`)}
        </select>
      `,
      showCancelButton: true,
      confirmButtonColor: '#2F8BE6',
      cancelButtonColor: '#F55252',
      confirmButtonText: 'Yes!',
      cancelButtonText: 'Cancel',
      customClass: {
        confirmButton: 'btn btn-warning',
        cancelButton: 'btn btn-danger ml-1'
      },
      buttonsStyling: false,
    }).then(result => {
      if (result.isConfirmed) {
        const selectedValue = (document.getElementById('dropdown') as HTMLSelectElement).value;

        if (selectedValue) {
          let body = {
            workon: selectedValue
          }
          this.apiService.updateJob(this.job_id, body).subscribe((res: any) => {
            if (res.statusCode === 200) {
              swal.fire({
                icon: "success",
                title: 'Move!',
                text: 'Updated Successfully.',
                customClass: {
                  confirmButton: 'btn btn-success'
                },
              })
              this.setAndGetJobByStatus()
            }
            else {
              swal.fire({
                icon: "error",
                title: 'Move!',
                text: `${res.error}`,
                customClass: {
                  confirmButton: 'btn btn-success'
                },
              })
            }
          })
        }

      }
    });


  }
  getProjectTypeId(id, name) {
    this.project_type = name
    if(name === 'All'){
      this.workon_id = ''
      this.project_type = name
      this.setAndGetJobByStatus()
    }
    if(name !== 'All'){
      this.workon_id = id
      this.project_type = name
      this.setAndGetJobByStatus()
    }

    // this.apiService.getJobByWorkOn(id, 1, 100).subscribe((res: any) => {
    //   if (res.statusCode === 200) {
    //     this.rows = res.data.items
    //     this.page.totalPages = res.data.totalCount
    //   }
    // })

  }

  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }
  onSelectFile(event:any){
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      this.fileData = event.target.files[0];
      reader.readAsDataURL(event.target.files[0]);
      reader.onload=(event)=>{
        this.imgUrl=reader.result
      }
    }
  }
  resetFile(){
    this.fileData=null
    this.imgUrl=null
  }
  uploadImagePopup(content,data){
    this.job_id = data._id
    if(data){
      this.isEdit = true
      this.job_id = data._id
      this.fileData = data.image
    }
    if(!data.image){
      this.isEdit = false
    }
    const modalOptions: NgbModalOptions = {
      size: '700', // Set custom width here
      backdrop: 'static',
    };
   
    const modalRef = this.modalService.open(content, modalOptions);
    modalRef.result.then((result) => {
      this.isEdit = false
      this.job_id = ''
      this.fileData =null
    }, (reason) => {
       this.isEdit = false
      this.job_id = ''
      this.fileData =null
    });
  }
  uploadImage(){
    let formData = new FormData();
    formData.append('image',this.fileData)
    this.apiService.uploadJobImage(this.job_id,formData).subscribe((res:any)=>{
      if(res?.statusCode ===200){
        this.toastr.success('Image uploaded successfully')
        this.modalService.dismissAll()
        this.setAndGetJobByStatus()
      }
      else this.toastr.error(res?.error)
    })
  }
  openNotesModal(content,data) {
    const modalOptions: NgbModalOptions = {
      size: 'lg' // Set custom width here
    };
    this.lead_data = data

    const modalRef = this.modalService.open(content, modalOptions);
    modalRef.result.then((result) => {
      this.isEditNotes = false
      this.isEditAlertNotes = false
      this.isEditAdminNotes = false

      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      this.isEditNotes = false
      this.isEditAlertNotes = false
      this.isEditAdminNotes = false      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  updateNotes(prop) {
      let body:any
      if(prop =='alert notes'){
          body={
            alert_notes : this.lead_data.alert_notes
          }
      }
      if(prop =='notes'){
        body={
          notes : this.lead_data.notes
        }
      }
      if(prop =='admin notes'){
        body={
          admin_notes : this.lead_data.admin_notes
        }
      }

        
      this.apiService.updateJob(this.lead_data._id,body).subscribe((res: any) => {
        if (res?.isSuccess) {
          this.toastr.success(`${prop} update successfully`)
          if(prop =='alert notes') this.isEditAlertNotes =false
          if(prop =='notes') this.isEditNotes =false
          if(prop =='admin notes') this.isEditAdminNotes =false

        }
        else this.toastr.error(res.error)
      })
  }

   
getClientList() {
  this.spinner.show(undefined,
   {
     type: 'ball-triangle-path',
     size: 'medium',
     bdColor: 'rgba(0, 0, 0, 0.8)',
     color: '#fff',
     fullScreen: true
   });
 // let status = this.type_List.find((item) => item.name == this.activeTab);
 this.apiService.getAllClients(1,100).subscribe((res: any) => {
   this.spinner.hide()
   let data = res?.data?.items
    this.clients_list = data?.map((item)=> item?.user_id[0])
 })
}
getClientId(event){
  this.selected_client
}
openModal3(content, id) {
  this.row_id = id

  const options: NgbModalOptions = {
    size: 'md', // set the size of the modal
    backdrop: 'static', // set whether clicking outside the modal closes it
    centered: true // set whether the modal is centered vertically
  };
  const modalRef = this.modalService.open(content,options);
  modalRef.result.then((result) => {
    // console.log(`Modal closed with result: ${result}`);
  }, (reason) => {

    // console.log(`Modal dismissed with reason: ${reason}`);
  });
}
updateClient(){
  let body={
    project : this.row_id,
  }
  this.apiService.updateClient(this.selected_client,body).subscribe((res:any)=>{
    if(res?.isSuccess){
      this.toastr.success('Attach Client Successfully')
      this.modalService.dismissAll()
      this.setAndGetJobByStatus()
    }
    else this.toastr.error(res.error)
  })
}
goToSprint(id){
  window.open(`/projects-tracker/project-sprint?status=open&id=${id}`,'_blank');
}

}

